import { render, staticRenderFns } from "./EditCommentsModal.vue?vue&type=template&id=58024216&scoped=true"
import script from "./EditCommentsModal.vue?vue&type=script&lang=js"
export * from "./EditCommentsModal.vue?vue&type=script&lang=js"
import style0 from "./EditCommentsModal.vue?vue&type=style&index=0&id=58024216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58024216",
  null
  
)

export default component.exports